import { connect } from '@/common/lib/riot-redux';
import Notify from './notify.riot';
import { ntfyRegisterUrlFailure, ntfyRegisterUrlRequest, ntfyRegisterUrlSuccess } from './notify.action';
import { ajaxPost } from '../ajax';

const mapStateToProps = (state, props) => {
  const registerKey = props.registerKey;
  return {
    registerKey
  };
};

const mapDispatchToProps = (dispatch) => ({
  async ntfyRegisterUrl(registerKey) {
    dispatch(ntfyRegisterUrlRequest());
    try {
      const res = await ajaxPost('/notify', {
        method: 'ntfyRegisterUrl',
        key: registerKey
      });
      dispatch(ntfyRegisterUrlSuccess(res));
      return 1;
    } catch (e) {
      dispatch(ntfyRegisterUrlFailure(e));
      return 2;
    }
  }
});

export default connect(Notify, mapStateToProps, mapDispatchToProps);